import styled from '@emotion/styled';

import { breakpoints, fontFamily, turquoise } from '~/styles';

import img from './icon-video-quality.svg';
import { nextButtonStyles } from '../NextButton/addNextButton';

const basePlayerStyles = `
  width: 100%;
  height: 100%;
  .brightcove-react-player-loader {
    width: 100%;
    height: 100%;
    .video-js {
      width: 100%;
      height: 100%;
      background: black;
      font-family: ${fontFamily};
    }
  }
  ${breakpoints.minDesktop}{
    .vjs-control-bar{
      font-size: 14px !important;
      height: 50px;
      .vjs-rewind-n-seconds{
        display: flex;
        justify-content: center;
        img{
          height: 32px !important;
          margin-top: 5px;
        }
      }
      .vjs-time-control.vjs-current-time{
        padding-right: 0;
      }
      .vjs-time-control.vjs-duration{
        padding-left: 0;
      }
      .vjs-info-button{
        display: flex;
        justify-content: center;
        img{
          height: 32px !important;
          margin-top: 5px;
        }
      }
    }
  }
`;

const playButtonStyles = `
  .vjs-big-play-button {
    z-index: 20;
    margin: 0;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    width: 70px;
    height: 70px;
    background: white;
    color: grey;
    font-size: 64px;
    line-height: 64px;
  }
`;

const captionsStyles = `
  .vjs-menu-item.vjs-selected {
    background: ${turquoise} !important;
  }

  .vjs-text-track-settings {
    z-index: 10;
  }
`;

const menuButtonsStyles = `
  .vjs-control-bar > .vjs-button{
    flex-shrink:1;
  }
`;

const replaceVideoQualityIcon = `
  .vjs-quality-menu-button .vjs-icon-placeholder::before{
    content: url(${img}) !important;
    text-align: right;
    position: absolute;
    left: unset;
    width: 20px;
    height: 20px;
    right: 10px;
    top: 1px;
    ${breakpoints.minDesktop}{
       width: 28px;
       height: 28px;
       top: 2px;
       right: 15px;
    }
  }
`;

/*
 * TODO remove nextButtonStyles after we migrate to emotions
 * it's wrong from dependencies perspective to inject nextButtonStyles to the global player styles.
 * It can be done by emotion's 'css', but we cannot use it until we fully migrate to emotions.
 * */
export const BrightcovePlayerStylesWrapper = styled.div<{
  ready: boolean;
  showPosterOnEnd?: boolean;
}>`
  ${({ ready }) => ({ opacity: ready ? 1 : 0 })}
  transition: opacity .5s;
  ${basePlayerStyles}
  ${playButtonStyles}
  ${captionsStyles}
  ${menuButtonsStyles}
  ${replaceVideoQualityIcon}
  ${nextButtonStyles}

  ${({ showPosterOnEnd }) =>
    showPosterOnEnd &&
    `.video-js.vjs-ended .vjs-poster {
      display: block;
    }
`}
`;
